import api from "./api";

export const getHubEvents = async (hubId, filter = {}) => {
  const params = {
    hubId,
    pageNumber: filter.pageNumber ?? 1,
    pageSize: filter.pageSize ?? 10,
    ...(filter.search && { search: filter.search }),
  };
  const res = await api.get("/event/hub", { params });
  const data = res.data?.data;
  return {
    data: data?.data?.$values ?? data?.data ?? [],
    totalRecords: data?.totalRecords ?? 0,
    totalPages: data?.totalPages ?? 0,
  };
};

export const getEventById = async (id) => {
  const res = await api.get(`/event/${id}`);
  const data = res.data?.data;
  if (!data) return null;
  if (data.tickets?.$values) data.tickets = data.tickets.$values;
  if (data.extras?.$values) data.extras = data.extras.$values;
  if (data.dates?.$values) data.dates = data.dates.$values;
  return data;
};

export const getEventTicketSales = async (eventId) => {
  const res = await api.get(`/statistics/event/${eventId}/summary`);
  return res.data?.data ?? null;
};